
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserRoomStateData, User, MessageHistory } from '@/utils/models';
import { DataService } from '@/service/DataService';

@Component({ components: {} })
export default class MessageEditor extends Vue {
  @Prop() messageHistories!: MessageHistory[];
  @Prop() dataService!: DataService;
  @Emit() messageSended() {}
  emojis: string[] = ['👍', '😁', '🤩', '🙌', '👏', '🙏', '😓'];
  editingUserMessage = '';
  shouldSendSelectedMessage = false;
  hasScrollbar = false;
  get isDebugMode(): boolean {
    return this.$store.state.isDebugMode;
  }

  get isShowEditor(): boolean {
    return this.$store.state.isShowEditor;
  }
  get defaultEditingMessage(): string {
    return this.$store.state.defaultEditingMessage;
  }
  get storedShouldSendSelectedMessage(): boolean {
    return this.$store.state.shouldSendSelectedMessage;
  }
  mounted() {
    this.onChangeDefaultEditingMessage(this.defaultEditingMessage);
    this.shouldSendSelectedMessage = this.storedShouldSendSelectedMessage;
    this.checkScrollbar();
  }
  updated() {
    this.checkScrollbar();
  }
  beforeDestroy() {}
  sendUserMessage(): void {
    this.dataService.emitMessage(this.editingUserMessage);
    this.editingUserMessage = '';
    this.messageSended();
    this.$store.commit('SetShouldSendSelectedMessage', this.shouldSendSelectedMessage);
  }
  onEnterSendUserMessage(ev: KeyboardEvent) {
    if (!ev.shiftKey && !ev.ctrlKey && !ev.altKey) {
      ev.preventDefault();
      ev.stopPropagation();
      this.sendUserMessage();
    }
  }
  updateFavoriteMessageHistory(messageId: string, isFavorite: boolean) {
    this.dataService.emitUpdateFavoriteMessageHistory(messageId, isFavorite);
  }
  onPinMessage(messageId: string) {
    this.updateFavoriteMessageHistory(messageId, true);
  }
  onUnpinMessage(messageId: string) {
    this.updateFavoriteMessageHistory(messageId, false);
  }
  @Watch('defaultEditingMessage')
  onChangeDefaultEditingMessage(newVal: string): void {
    this.editingUserMessage = newVal;
    this.$nextTick(() => {
      const messageTextarea = this.$refs.messageTextarea as HTMLTextAreaElement | undefined;
      messageTextarea?.focus();
      messageTextarea?.select();
    });
  }
  insertMessage(message: string) {
    const messageTextarea = this.$refs.messageTextarea as HTMLTextAreaElement | undefined;
    if (!message || !messageTextarea) {
      return;
    }
    const startPos = messageTextarea.selectionStart || 0;
    const endPos = messageTextarea.selectionEnd || 0;
    const prefix = this.editingUserMessage.slice(0, startPos);
    const suffix = this.editingUserMessage.slice(endPos);
    this.editingUserMessage = prefix + message + suffix;
    messageTextarea.setRangeText(message, startPos, endPos, 'end');
    setTimeout(() => {
      messageTextarea.focus();
      messageTextarea.setSelectionRange(startPos + message.length, startPos + message.length);
    }, 50);
  }
  sendSelectedMessage(message: string) {
    const messageTextarea = this.$refs.messageTextarea as HTMLTextAreaElement | undefined;
    if (!message || !messageTextarea) {
      return;
    }
    this.editingUserMessage = message;
    this.sendUserMessage();
  }
  deleteMessageHistory(messageId: string) {
    this.dataService.emitDeleteMessageHistory(messageId);
  }
  checkScrollbar() {
    const scrollable = this.$refs.scrollable as HTMLDivElement;
    this.hasScrollbar = scrollable.scrollHeight > scrollable.clientHeight;
  }
}
